module.exports = "/_next/static/images/9fdc0276f56aeaeb02ebfe3f40084654-roxinho-details-metalico-lg@1x.jpg";